"use client";

import { useTranslations } from "next-intl";
import { PagePropsBasicType } from "@/types/basic";
import { I18nLocalesType } from "@/i18n/i18n-config";
import { getTranslations } from "next-intl/server";

type PagePropsType = PagePropsBasicType & {
  params: {
    locale: I18nLocalesType;
  };
};

export async function generateMetadata({ params: { locale } }: PagePropsType) {
  const t = await getTranslations({ locale, namespace: "ErrorPage" });

  return {
    title: t("notFoundTitle"),
  };
}

export default function NotFoundPage() {
  const t = useTranslations("ErrorPage");

  return (
    <>
      <a href={"/"} className="error-page">
        <p className="info">{t("notFoundBack")}</p>
        <h1 className="internal">
          <span className="five">4</span>
          <span className="zero">0</span>
          <span className="zero">4</span>
        </h1>
      </a>
    </>
  );
}
